import { render, staticRenderFns } from "./ElectricityTrendYear.vue?vue&type=template&id=c3c54172&scoped=true&"
import script from "./ElectricityTrendYear.vue?vue&type=script&lang=js&"
export * from "./ElectricityTrendYear.vue?vue&type=script&lang=js&"
import style0 from "./ElectricityTrendYear.vue?vue&type=style&index=0&id=c3c54172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c54172",
  null
  
)

export default component.exports